export default {
  INSURANCE_INFO: "insuranceInfo",
  MANUAL: "manual",
  GENERALI: "generali",
}